import { render } from "./CloseSvg.vue?vue&type=template&id=4c9c318b"
import script from "./CloseSvg.vue?vue&type=script&lang=js"
export * from "./CloseSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__